import type { Store } from '@types'

export type WiredHistoryStore = {
  getState: () => Store
  setState: (
    partial: Store | Partial<Store> | ((state: Store) => void),
    replace?: boolean,
  ) => void
}

/** Referencia estable al store; sobrevive recargas HMR del motor de historial. */
export const wiredHistoryStoreRef: { current: WiredHistoryStore | null } = { current: null }
